import React from 'react';
import { DrawerV2 } from '@withjoy/joykit';

export const BottomSheet = ({ isOpen, onClose, children }: { isOpen: boolean; onClose: () => void; children: React.ReactNode }) => {
  return (
    <DrawerV2
      size="auto"
      useBackdrop
      anchor="bottom"
      isOpen={isOpen}
      onClose={onClose}
      disableCloseOnOutsideClick
      disableCloseOnEscapeKeyClick
      disableFocusLockRemoveScroll
      stickyBehavior="header-footer"
      overrides={{ Content: { props: { maxHeight: '97%', height: '97%', width: '100%', borderTopLeftRadius: 4, borderTopRightRadius: 4, userSelect: 'text' } } }}
    >
      {children}
    </DrawerV2>
  );
};
